// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2x6xp","hidden":"_2E9Ks","container":"_3RETy","frame":"_3Ouvj"};